import { render } from "./SubFooterView.vue?vue&type=template&id=43297978&scoped=true"
import script from "./SubFooterView.vue?vue&type=script&lang=js"
export * from "./SubFooterView.vue?vue&type=script&lang=js"

import "./SubFooterView.vue?vue&type=style&index=0&id=43297978&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43297978"]])

export default __exports__